<template>
  <div class="m-wrap m-pc">
    <Header :extras="extras"></Header>
    <Banner :extras="extras"></Banner>
    <!-- 推广链接已关闭时显示提示 -->
    <div class="over-box" v-if="isTrackClosedMessage">
      <FormStatus :status="'over'" :platform="platform" />
      <a-button
        class="btn-default"
        v-show="
          extraItem.extras('signupfont.display') == 1 &&
          formInfo.moduleType == '2' &&
          whereform == 'webinar'
        "
        @click="togoVerify()"
      >
        {{ extras | extra("signupfont.model") }}
      </a-button>
      <a-button
        class="btn-default"
        v-show="
          extraItem.extras('verifyfont.display') == 1 &&
          formInfo.instanceId &&
          formInfo.moduleType != 1 &&
          !(formInfo.moduleType == '2' && whereform == 'webinar')
        "
        @click="togoVerify()"
      >
        {{ extras | extra("verifyfont.model") }}
      </a-button>
    </div>
    <div
      class="m-container"
      :class="extraItem.extras('banner.bannerType')"
      v-else-if="preview || formInfo.status == 1"
    >
      <h4
        class="title"
        :style="{
          color: extraItem.extras('titlefont.color'),
          fontSize: pxOrVw(extraItem.extras('titlefont.size')),
          fontWeight:
            extraItem.extras('titlefont.weight') == 'default'
              ? '500'
              : extraItem.extras('titlefont.weight'),
        }"
      >
        {{ formInfo.title }}
      </h4>
      <CField
        class="field-wrap"
        :formData="formData"
        :platform="platform"
        :extras="extras"
        :rulesJump.sync="rulesJump"
        ref="formRef"
      />
      <div class="split-line"></div>
      <div class="bottom">
        <a-button
          class="submit ant-btn-primary-default"
          @click="submit()"
          :disabled="isSubmitting"
          :style="{
            backgroundColor:
              extraItem.extras('themecolor.bgcolor') === '#1665D8' &&
              extraItem.extras('submitfont.bgcolor')
                ? extraItem.extras('submitfont.bgcolor')
                : extraItem.extras('themecolor.bgcolor'),
            color: extraItem.extras('submitfont.color'),
          }"
        >
          {{ extras | extra("submitfont.model") }}
        </a-button>
        <a-button
          class="btn-default"
          v-show="
            extraItem.extras('signupfont.display') == 1 &&
            formInfo.moduleType == '2' &&
            whereform == 'webinar'
          "
          @click="togoVerify()"
        >
          {{ extras | extra("signupfont.model") }}
        </a-button>
        <a-button
          class="btn-default"
          v-show="
            extraItem.extras('verifyfont.display') == 1 &&
            formInfo.instanceId &&
            formInfo.moduleType != 1 &&
            !(formInfo.moduleType == '2' && whereform == 'webinar')
          "
          @click="togoVerify()"
        >
          {{ extras | extra("verifyfont.model") }}
        </a-button>
      </div>
    </div>
    <FormStatus
      v-else
      :status="formInfo.status == 0 ? 'nostart' : 'over'"
      :platform="platform"
    ></FormStatus>
    <Card :tenantId="tenantId"></Card>
  </div>
</template>

<script>
import Header from "../../../stempcore/src/core/components/common/Header.vue";
import Banner from "../../../stempcore/src/core/components/common/Banner.vue";
import CField from "@/components/CField.vue";
import FormStatus from "@/components/FormStatus.vue";
import mixinConfig from "../../mixin/config.js";
import mixin from "../../mixin/form.js";
import Card from "../../../stempcore/src/core/components/common/Card";
export default {
  name: "PcIndex",
  mixins: [mixinConfig, mixin],
  components: {
    Header,
    Banner,
    CField,
    FormStatus,
    Card,
  },
  data() {
    return {
      platform: "pc",
    };
  },
};
</script>
